import { FC } from 'react';
import { ICON_NAMES } from '@belong/types';
import * as styles from './styles';

export interface IDropdownLink {
  'aria-current'?: any;
  'aria-label'?: string;
  href?: string;
  iconName?: ICON_NAMES;
  label: string;
  onClick?: any;
  onBlur?: any;
  onKeyDown?: any;
  id?: string;
  csr?: boolean;
}

export const DropdownLink: FC<IDropdownLink> = ({ label, iconName, ...wrapperProps }: IDropdownLink) => (
  <styles.Wrapper {...wrapperProps}>
    {iconName && <styles.StyledIcon name={iconName} role="presentation" />}
    {label}
  </styles.Wrapper>
);
DropdownLink.displayName = 'DropdownLink';
